var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellphoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75L9 22.75C4.59 22.75 3.25 21.41 3.25 17L3.25 7C3.25 2.59 4.59 1.25 9 1.25L15 1.25C19.41 1.25 20.75 2.59 20.75 7L20.75 17C20.75 21.41 19.41 22.75 15 22.75ZM9 2.75C5.42 2.75 4.75 3.43 4.75 7L4.75 17C4.75 20.57 5.42 21.25 9 21.25L15 21.25C18.58 21.25 19.25 20.57 19.25 17V7C19.25 3.43 18.58 2.75 15 2.75L9 2.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.25L10 6.25C9.59 6.25 9.25 5.91 9.25 5.5C9.25 5.09 9.59 4.75 10 4.75L14 4.75C14.41 4.75 14.75 5.09 14.75 5.5C14.75 5.91 14.41 6.25 14 6.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 19.8598C10.7302 19.8598 9.7002 18.8298 9.7002 17.5598C9.7002 16.2898 10.7302 15.2598 12.0002 15.2598C13.2702 15.2598 14.3002 16.2898 14.3002 17.5598C14.3002 18.8298 13.2702 19.8598 12.0002 19.8598ZM12.0002 16.7498C11.5602 16.7498 11.2002 17.1098 11.2002 17.5498C11.2002 17.9898 11.5602 18.3498 12.0002 18.3498C12.4402 18.3498 12.8002 17.9898 12.8002 17.5498C12.8002 17.1098 12.4402 16.7498 12.0002 16.7498Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphoneIcon);
export default __webpack_public_path__ + "static/media/cellphoneIcon.af2b9f685416bed1aca7de69337d86a7.svg";
export { ForwardRef as ReactComponent };